import React from 'react'
import { translations } from '../../../../utils/translations/translations-manager'
import { recurrenceIntervals } from '../../../../assets/donations/recurrence-intervals'
import { RecurrenceTranslations } from '@cents/translations-utils'
import { Recurrence } from '../../../../types/donation/recurrence'

export function ContractRecurrenceInput({
  value,
  error,
  setValue,
}: {
  value: Recurrence | undefined
  error: string | undefined
  setValue: (value: Recurrence | undefined) => void
}): JSX.Element {
  // TODO: Picklist
  return (
    <>
      {' '}
      <select
        value={Object.entries(recurrenceIntervals).find(([key, val]) => val.interval === value?.interval && val.count === value?.count)?.[0] || ''}
        onChange={event => {
          setValue(event?.target.value ? (recurrenceIntervals[event.target.value as keyof typeof recurrenceIntervals] as Recurrence) : undefined)
        }}
        className="h-10 py-2 pl-4 border-0 text-base lg:text-lg bg-cents-grey rounded-2xl focus:ring-0"
      >
        <option value={''}>{translations.texts.select_a_recurrence.toString()}</option>
        {Object.entries(recurrenceIntervals).map(([key, value]) => (
          <option key={key} value={key}>
            {RecurrenceTranslations.getRecurrenceString(translations, { interval: value.interval, count: value.count })}
          </option>
        ))}
      </select>
      {error && (
        <div className="h-4 mb-4 text-red-500">
          <p>{error}</p>
        </div>
      )}
    </>
  )
}
